import { createFileRoute } from "@tanstack/react-router"
import { AdminPage } from "@/components/pages/admin"

export const Route = createFileRoute("/_authenticated/_admin/admin")({
	component: AdminPage,
})
